import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommonModule, NgFor} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {v4 as uuid} from "uuid";
import {AlertService} from "../../../../services/local/alert/alert.service";
import {AlertModel} from "../../../../models/AlertModel";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-alert-bar',
  standalone: true,
  imports: [MatIconModule, CommonModule, NgFor],
  templateUrl: './alert-bar.component.html',
})
export class AlertBarComponent implements OnInit, OnDestroy {

  // Property to hold alert stack
  alertStack: AlertModel[] = [];

  // Alert Subscription
  private subscription$: Subscription = new Subscription();

  constructor(
    private alertService: AlertService,
  ) {
    // Empty Constructor
  }

  ngOnInit(): void {
    // Show Alert
    this.showAlert()
  }

  showAlert() {
    this.subscription$ = this.alertService.toggleAlert.subscribe((result: AlertModel) => {

      // Generate UUID
      const uid = uuid();

      // Start Timout
      setTimeout(() => {
        this.closeAlert(uid);
      }, result.timeout ? result.timeout : 5000);

      if (!this.alertStack.find((alert: AlertModel) =>
        alert.title === result.title &&
        alert.description === result.description &&
        alert.variant === result.variant)) {
        this.alertStack.unshift({
          title: result.title ?? '',
          description: result.description ?? '',
          variant: result.variant,
          message: result.message ?? '',
          position: result.position,
          timeout: result.timeout ? result.timeout : 5000,
          uid: uid
        });
      }
    });
  }

  closeAlert(uid?: string) {
    this.alertStack = this.alertStack.filter((alert: AlertModel) => alert?.uid !== uid);
  }

  getToastStyles = (type?: string): string => {
    const styles: Record<string, string> = {
      success: "border-l-[6px] border-[#3BC279] bg-[#C5F7DD]",
      info: "border-l-[6px] border-[#226CF4] bg-[#CCE3FF]",
      warning: "border-l-[6px] border-[#E7A027] bg-[#FFE8C3]",
      error: "border-l-[6px] border-[#E8594D] bg-[#FFD0CB]",
      custom: "border-l-[6px] border-[#707584] bg-[#E9E8EB]",
    };
    return type ? styles[type] || "" : styles['error'];
  };

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

}
